/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const subscriptionPurchaseResponseSchema = z
	.object({
		confirmation_url: z.url(),
		subscription_payment_id: z.uuid(),
	})
	.describe("Ответ на инициацию покупки.");
